import React, { useEffect, useState, useContext } from 'react';
import ImageComponent from 'atoms/Image';
import MARKETING_HERO_CONSTANTS from '../Constants/MarketingConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { WELCOME_TEXT } from 'organisms/PastOrderComponent/Constants/PastOrderConstants';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { useSelector } from 'react-redux';
import { orderBtnAnalytics, clickImageAnalytics, extractAnalyticsData } from '../MarketingUtilities/marketingUtils';
import { UserOrderContext } from '../../../../context/context';
import START_ORDER_CONSTANTS from '../../../StartOrderComponent/Constants/startOrderConstants';
import { setAnalyticEventOnSingleBanner } from 'organisms/MarketingHero/AU/MarketingUtilities/marketingUtils';

export const SingleBannerComponent = props => {
  const { contentData, userParams, history } = props;
  const { CAROUSEL_IMAGE_CLICK, DISPOSITION_DATA } = MARKETING_HERO_CONSTANTS;
  const profileReducer = useSelector(data => data.profileReducer);
  const { SELECTED_TILE_DATA, SET_REDIRECTION_PATH } = START_ORDER_CONSTANTS;
  const basicData = profileReducer?.basic;
  const loggedIn = userParams?.loggedIn;
  const { localized } = useSelector(data => data?.appStateReducer?.userStatus);
  const { headline, noteLine, showButton, buttonText, image, analyticsData } = contentData;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { currencyShortName } = tenantReducer;
  const ind = useState(0);

  useEffect(() => {
    const { fields } = analyticsData;
    const currency = currencyShortName;
    const index = 0;
    let itemsArray = [];
    const {
      item_variant = '',
      item_name = '',
      creative_name = '',
      item_category = '',
      item_id = '',
      location_id = '',
      price = '',
      promotion_id = '',
      item_list_name = '',
      item_list_id = '',
      quantity = '',
      item_brand = '',
      affiliation = '',
      discount = '',
      creative_slot = '',
      coupon = '',
      promotion_name = '',
    } = fields;
    itemsArray.push({
      item_id,
      item_name,
      affiliation,
      coupon,
      creative_name,
      creative_slot,
      currency,
      discount,
      index,
      item_brand,
      item_category,
      item_list_id,
      item_list_name,
      item_variant,
      location_id,
      price,
      promotion_id,
      promotion_name,
      quantity,
    });
    const ecommerceObject = {
      creative_name,
      creative_slot,
      location_id,
      promotion_id,
      promotion_name,
    };
    setAnalyticEventOnSingleBanner(ecommerceObject, itemsArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const orderNowClick = (analyticsDataInfo, index, clickFlag, data) => {
    const indVal = 0;
    const itemdetails = extractAnalyticsData(analyticsDataInfo);
    clickImageAnalytics(analyticsDataInfo, indVal, itemdetails, currencyShortName);
    const item = {
      linkTo: data?.internalUrl,
      name: analyticsDataInfo?.fields?.item_name,
    };
    if (!localized) {
      userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
      userOrderStateDispatch({ type: SET_REDIRECTION_PATH, value: { redirectionOrder: data.linkTo } });
    } else {
      if (clickFlag !== CAROUSEL_IMAGE_CLICK) {
        clickImageAnalytics(analyticsDataInfo, index);
      }

      orderBtnAnalytics(analyticsDataInfo, index);
      userOrderStateDispatch({
        type: SELECTED_TILE_DATA,
        value: {
          selectedData: {
            name: item.name,
          },
        },
      });
      history.push({
        pathname: `${item.linkTo}`, // use linkTo
      });
    }
  };
  /* istanbul ignore next */
  return (
    <React.Fragment>
      <div className='market-hero-global-aus'>
        <div className='removePointer single-div-container'>
          <div className='grid-container'>
            {userParams?.loggedIn && (
              <div className='strip-continer'>
                <div className='strip-Icon'>
                  <ImageComponent
                    data-testid='image-strip-component'
                    srcFile={IMAGE_PATH.StripesIcon}
                    className='strip-icon-img'
                  />
                </div>
                <div data-testid='greeting-test' className='greeting-heading'>
                  <span>
                    {' '}
                    {translateWithI18Next(WELCOME_TEXT)}, {basicData?.firstName}{' '}
                  </span>
                </div>
              </div>
            )}
            <ImageComponent
              data-testid='image-component'
              srcFile={image?.fields?.file?.url}
              className='carausel-image'
            />
            <div className='market-hero-description' tabIndex='0' role='clickable image' key={ind}>
              <div className={`market-hero-description ${loggedIn && 'market-hero-description-signin'}`}>
                {headline && <div className='largeTextHero-aus'>{headline}</div>}
                {showButton && buttonText && (
                  <ContainedButton
                    variant={ButtonType.primary}
                    className={'carauselOrderNow-aus single-button'}
                    data-testid={`click-handler`}
                    onClickHandler={() => orderNowClick(analyticsData, ind, null, contentData)}
                  >
                    <span>{buttonText}</span>
                  </ContainedButton>
                )}
                <div className='carauselOrderNow-NoteLine'>{noteLine}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SingleBannerComponent;
